import React, { createContext } from 'react';
import { Filters } from '../ContentFilters';
import { Publication } from '@amzn/awscat-pattern-library-service-model';

export interface HomePageCtxData {
  filteredPublications: Publication[];
  setFilteredPublications: React.Dispatch<React.SetStateAction<Publication[]>>;

  filterOptions: Filters;
  setFilterOptions: React.Dispatch<React.SetStateAction<Filters>>;

  allPublications: Publication[];
  searchTerm: string;
}

// @ts-expect-error TS2345 - strict migration
const HomePageCtx = createContext<HomePageCtxData>(undefined);

export default HomePageCtx;
